<template>
  <AppLayout>
    <router-view />
  </AppLayout>
</template>

<script>
import AppLayout from './components/AppLayout.vue'

export default {
  components: {
    AppLayout
  },

};
</script>

<style>
/* Global styles */
body {
  font-family: 'Roboto', sans-serif; /* Nunito Sans font */
  font-size: 14px; /* Font size set to 12px */
  
}

.content-container  {
  background: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%);
  color: #FFF; /* Ensure text color contrasts well with the background */
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  height: 100%; /* Full height */
  width: 100%; /* Full width */
}

.toolbar button, .view-options button, .event-form button, .button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.toolbar button:hover, .view-options button:hover, .event-form button:hover, .button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

.risk-score-card {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Aligns items to start and end */

  max-width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-image: linear-gradient(135deg, #36454f 0%, #5a6978 50%, #b0bec5 100%);
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .stylish-links ul li {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .stylish-links ul li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  
  .stylish-links ul li:hover {
    background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
  }
  
  .stylish-links ul li:hover a {
    color: #fff;
  }
</style>